<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> /<a href="javascript:void(0)" style="color:#888888" @click="urlTo('applyIndex')"> 个人办事</a> / <span style="color:#2e2e2e">{{nav_name}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="advice" >
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign8.png">{{nav_name}}</span><em><img src="../../../static/images/required.png">为必填项</em></h2>
            <dl class="advice_tips" style="color: red">
              <dt>温馨提示</dt>
              <dd>  1、重病范围：先天性心脏病、慢性阻塞性肺气肿、白血病、地中海贫血、肾病综合征、关节病（髋、膝）、肾炎、类风湿性关节炎、等其他重病；
              </dd>
              <dd>   2、家庭低保金=家庭人口数*低保标准金额-家庭月总收入；</dd>
              <dd>    3、此工具根据相关政策文件进行的粗略测算，测算金额不是实际办理结果。</dd>

            </dl>
            <el-form  :rules="rules" :model="ruleForm" label-width="100px" ref="ruleForm" class="demo-ruleForm">
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="受理单位" prop="selectedRegions">
                    <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"   @change="onSelectedRegion" placeholder="请选择受理单位" clearable style="width: 200px;"></el-cascader>
                  </el-form-item>
                </div></el-col>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                  <el-form-item  label="户籍性质：" prop="BLANTypeCode">
                    <el-select
                      v-model="ruleForm.BLANTypeCode"
                      collapse-tags
                      placeholder="请选择" style="width: 200px;">
                      <el-option
                        v-for="item in BLANType"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code" >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="家庭人口数" prop="peopleTotal">
                    <el-input  type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" v-model="ruleForm.peopleTotal" placeholder="请输入" maxlength="3" style="width:200px"></el-input>
                  </el-form-item>
                </div></el-col>
              </el-row>
              <div v-if="ruleForm.peopleTotal>0">
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="健康人数（除开老年人、未成年人、重病、重残）" >
                      <template >
                        <el-input-number size="medium"  v-model="peopleNum[0].num" :min="min" @change="calculateTotal"  :max="(achieveMax)? ruleForm.peopleTotal:peopleNum[0].num" ></el-input-number>
                      </template>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="60岁及以上老年人" >
                      <template >
                        <el-input-number size="medium"  v-model="peopleNum[1].num"  :min="min" @change="calculateTotal"  :max="(achieveMax)? ruleForm.peopleTotal:peopleNum[1].num" ></el-input-number>
                      </template>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="18岁以下未成年人" >
                      <template >
                        <el-input-number size="medium"  v-model="peopleNum[2].num"  :min="min" @change="calculateTotal"  :max="(achieveMax)? ruleForm.peopleTotal:peopleNum[2].num" ></el-input-number>
                      </template>
                    </el-form-item>
                  </div></el-col>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple">
                    <el-form-item  label="重病人数" >
                      <template >
                        <el-input-number size="medium"  v-model="peopleNum[3].num" :min="min" @change="calculateTotal"  :max="(achieveMax)? ruleForm.peopleTotal:peopleNum[3].num" ></el-input-number>
                      </template>
                    </el-form-item>
                  </div></el-col>
                </el-row>
                <el-row>
                  <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                    <el-form-item  label="重残人数（残疾等级为一二级残疾人）" >
                      <template >
                        <el-input-number size="medium"  v-model="peopleNum[4].num"  :min="min" @change="calculateTotal"  :max="(achieveMax)? ruleForm.peopleTotal:peopleNum[4].num" ></el-input-number>
                      </template>
                    </el-form-item>
                  </div></el-col>

                </el-row>
              </div>

              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-form-item  label="家庭月总收入" prop="allMoney">
                    <el-input  type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" v-model="ruleForm.allMoney" placeholder="请输入" maxlength="3" style="width:200px"></el-input>
                  </el-form-item>
                </div></el-col>

              </el-row>
              <el-row>
                <el-col style="padding-left: 13%" :span="9"><div class="grid-content bg-purple-light">
                  <el-button :loading="loading" type="primary" @click="search" style=" width: 120px;
    margin-left: 100px;" :disabled="disableds">计算</el-button>
                </div></el-col>

              </el-row>

           </el-form>
            <div v-if="totalShow" style="color: red;font-weight: 600;padding-left: 8%;padding-right: 8%;padding-top: 20px">
              预估你可以领取的家庭低保金为：{{total}}元/月，具体以实际办理结果为准。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "suggests",
    components:{
      headers,fixedDiv,footers
    },

    data() {
      let _self=this;
      return {
        disableds:false,
        totalShow:false,
        achieveMax:false,
        loading:false,
        maxPerson:0,
        min:0,
        selectedRegion:[],
        BLANType:[
          {code:'1',name:'城市户口'},
          {code:'0',name:'农村户口'},
        ],
        peopleNum:[
          {membership:1,num:0},
          {membership:2,num:0},
          {membership:3,num:0},
          {membership:4,num:0},
          {membership:5,num:0},
        ],
        ruleForm:{
          // selecteddepartOption:[],
          theTitle:'',
          allMoney:'',
          peopleTotal:'',
          BLANTypeCode:'',
          types:'',
          textarea:'',
          age:'',
          phone:'',
          verifyCode:'',
          smsCode:'',
        },
        rules:{
          selectedRegions:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          age:[{required:true ,validator:this.checkAge,tigger:'blur'}],
          BLANTypeCode:[{required:true,message:'请选择户籍性质',tigger:'change'}],
          peopleTotal:[{type:'number',required:true,message:'请输入家庭人口数',tigger:'change'}],
          allMoney:[{required:true,message:'请输入家庭月总收入',tigger:'change'}],
        },


        props: {
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              //   if(node.value=='63010001'){
              //     const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 3}];
              //     resolve(nodes);
              //   }else{
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              //   }
              // }else{
              //   // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   // resolve(nodes);
              //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },

      }
    } ,

    watch: {
      width(n, o) {
        alert(n + 'w')
      },
      height(n, o) {
        alert(n + 'h')
      },
      'ruleForm.peopleTotal'(n, o) {
        this.peopleNum=[
          {membership:1,num:0},
          {membership:2,num:0},
          {membership:3,num:0},
          {membership:4,num:0},
          {membership:5,num:0},
        ],
        //string转int
        this.ruleForm.peopleTotal=this.ruleForm.peopleTotal*1;

        //判断当前选择的人数是否等于总人口，若大于，就禁用步进器，否则就恢复使用
        this.maxPerson=0;
        for (let i = 0; i < this.peopleNum.length; i++) {
          this.maxPerson+=this.peopleNum[i].num;
        }
        if (this.ruleForm.peopleTotal==this.maxPerson){
          this.achieveMax=false;
        }else {
          this.achieveMax=true;
        }
      },

    },
    created(){
      // this.showClause=true;
      // this.initClause();
      //建议类别枚举
      this.service_code=this.$route.query.service_code;
      this.nav_name=this.$route.query.nav_name;



    },
    methods: {

      onSelectedRegion(v){
        if(this.selectedRegion && this.selectedRegion.length>0){
          this.partyId=this.selectedRegion[this.selectedRegion.length-1];
        }else{
          this.partyId="";
        }

      },


      search(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            if (''==this.partyId||-1==this.partyId||undefined==this.partyId){
              this.$message.error('请先选择区划！');
              return;
            }
            this.ruleForm.peopleTotal=parseInt(this.ruleForm.peopleTotal);
            if (this.ruleForm.peopleTotal>this.maxPerson){
              this.$message.error("请将家庭人数分配完毕！")
              return;
            }else if (this.ruleForm.peopleTotal<this.maxPerson){
              this.$message.error("分配人数总和不得大于家庭人口数！")
              return;
            }
            const options = {
              archive_type:'BLAN',
              part_id:this.partyId,
              member_total:this.ruleForm.peopleTotal,
              city_is:this.ruleForm.BLANTypeCode,
              member:this.peopleNum,
              familyIncome:this.ruleForm.allMoney,
            }
            this.totalShow = false;
            this.loading=true;
            this.$https.post("api/select/selectPaymentAmount.do", options, response => {
              if (response.status === 200 && response.data.code === 200) {
                this.totalShow = true;
                this.total = response.data.data.amount;
                this.loading=false;
              }
            })
          }else {
            this.totalShow = false;
            this.loading=false;
            return
          }
        })
      },
      calculateTotal(){

        //判断当前选择的人数是否等于总人口，若大于，就禁用步进器，否则就恢复使用
        this.maxPerson=0;
        for (let i = 0; i < this.peopleNum.length; i++) {
          this.maxPerson+=this.peopleNum[i].num;
        }
        if (this.ruleForm.peopleTotal==this.maxPerson){
          this.$message({
            message: '家庭成员已分配完成',
            type: 'success'
          });
          this.achieveMax=false;
        }else {
          this.achieveMax=true;
        }
      },
      countDown(times){
        var time;
        if(times){
          time=times;
        }else{
          time=this.$cookies.get("time2")
          if(!time){
            this.smsIsDisabled=false;
            return;
          }
        }
        time=time-1;
        this.$cookies.set("time2",time,time+"s")
        if(time<=0){
          this.smsIsDisabled=false;
          this.smsText="发送短信";
          this.$cookies.remove("time2")
          return
        }else{
          this.smsText=time+"秒"
          var t=this;
          setTimeout(function() {
            t.countDown(time);
          },1000)
        }

      },
      proving(){
        this.ruleForm.peopleTotal = this.ruleForm.peopleTotal.replace(/[^\.\d]/g,'');
        this.ruleForm.peopleTotal = this.ruleForm.peopleTotal.replace('.','');
      },
      urlTo(url, params) {
        this.$router.push({path: url, query: params || {}});
      },

      checkAge(rule, value, callback) {

        if (value<60) {
          return callback(new Error('请输入大于60的年龄！'))
        } else{
          callback()
        }
      },
      checkDepartId(rule,value,callback){
        if(!this.selectedRegion || this.selectedRegion.length<=0){
          return callback(new Error('请选择受理单位！'))
        }
        return  callback()
      },



    }
  }



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/calculate/BLANCalculation.vue